export const SET_COMPONENT_PROPS = 'SET_COMPONENT_PROPS';

// NOTE: Messasges in this file are intended for use with `iframeable`

export const isSetComponentPropsMessage = msg => {
  const {
    payload
  } = msg;
  return payload.type === SET_COMPONENT_PROPS && 'props' in payload;
};